import {
  Card,
  CardContent,
  Grid,
  Theme,
  Typography,
  useMediaQuery,
} from "@mui/material";

export default function ChecklistHeader() {
  const isMobile = useMediaQuery((theme: Theme) =>
    theme.breakpoints.down("md")
  );

  return (
    <Card
      sx={{
        width: "100%",
        backgroundColor: "myVerify.light",
        boxShadow: "0 16px #3E7787",
        marginBottom: 4,
      }}
    >
      <CardContent>
        <Grid
          item
          xs={10}
          sm={10}
          md={11}
          display="block"
          flexDirection="column"
          paddingLeft={3}
        >
          <Typography variant="h6" fontWeight={700} marginBottom={1}>
            Online Form
          </Typography>
          <Typography display={isMobile ? "none" : "show"} marginBottom={1}>
            Use the following checklist to organize your Professional Portfolio
            in the order listed below. You may check off each item in the last
            column as it is completed. Use this “My CDA® Professional Portfolio”
            sheet as the inside cover sheet for your Portfolio. Please see your{" "}
            <span style={{ fontStyle: "italic" }}>Competency Standards</span>{" "}
            book for a detailed explanation.
          </Typography>
        </Grid>
      </CardContent>
    </Card>
  );
}
